/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HeaderModule
 */

import { Component, OnDestroy } from '@angular/core';

import {
    combineLatest,
    Subject,
    takeUntil,
} from 'rxjs';

import { Store } from '@ngrx/store';
import { ADMIN_TENANT_NAME } from 'ajs/modules/core/core.constants';
import { selectUsername } from 'ng/root-store/user-profile/user-profile.selectors';

import {
    selectOauthProvider,
} from 'ng/root-store/controller-initial-data-store/controller-initial-data.selectors';

import './avi-main-header.component.less';

/**
 * @description Main header rendered at the top of the application.
 * @author alextsg
 */
@Component({
    selector: 'avi-main-header',
    templateUrl: './avi-main-header.component.html',
})
export class AviMainHeaderComponent implements OnDestroy {
    /**
     * If true, hides the tenant dropdown.
     */
    public hideTenantSelector = false;

    private ngDestroyed$ = new Subject();

    constructor(private readonly store: Store) {
        combineLatest([this.store.select(selectOauthProvider), this.store.select(selectUsername)])
            .pipe(takeUntil(this.ngDestroyed$))
            .subscribe(([oauthProvider, username]) => {
                this.hideTenantSelector = Boolean(oauthProvider) && username !== ADMIN_TENANT_NAME;
            });
    }

    /** @override */
    public ngOnDestroy(): void {
        this.ngDestroyed$.next(true);
        this.ngDestroyed$.complete();
    }
}
